export default {
  showDeleteRefundDialog: function () {
    return this.refundToDelete !== null
  }
}
